import { Box, Tooltip } from "@mui/material";

export const referenceImageTooltip =
  "A reference image acting as example of how this information renders on earthly.org";

export type ReferenceProps = {
  image: string;
  message?: string;
  radius?: number | string;
  alt: string;
  testId: string;
};

function Reference({
  image,
  alt,
  testId,
  message = referenceImageTooltip,
  radius = 0,
}: ReferenceProps) {
  return (
    <Tooltip followCursor title={message}>
      <Box
        component="img"
        data-testid={testId}
        sx={{
          display: "block",
          objectFit: "contain",
          width: "100%",
          height: "auto",
          maxHeight: 300,
          minWidth: 0,
          maxWidth: "550px",
          borderRadius: radius,
        }}
        alt={alt}
        src={image}
      />
    </Tooltip>
  );
}

export default Reference;
